import axios from 'axios';
export const getWithdrawalAddress = (code) => {
    return axios
        .get('custody/withdrawals/addresses', { params: { code } })
        .then((response) => {
        return response.data.records[0];
    });
};
